import { render } from "./TopNavigation.vue?vue&type=template&id=5fe3a156&ts=true"
import script from "./TopNavigation.vue?vue&type=script&lang=ts"
export * from "./TopNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__